<div class="text-right pull-right">
    <button type="button" class="btn btn-primary" [routerLink]="['/dealerCdk/homecdk']"> <i class="icon md-arrow-left mr-2"></i>
        Back</button>
</div>
<h2>
    Tracking log
</h2>

<hr>
<p-panel header="Dealer Details">
    <div class="col-md-12">
        <div class="row">
            <div class="form-group col-md-4">
                <label style="font-weight:600">Dealer Code:</label> {{DealerCode}}
            </div>
            <div class="form-group col-md-4">
                <label style="font-weight:600">Dealer Name:</label> {{DealerName}}
            </div>
            <div class="form-group col-md-4">
                <label style="font-weight:600">Time Zone:</label> {{TimeZone}}</div>
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label style="font-weight:600">City:</label> {{City}}</div>
            <div class="form-group col-md-4">
                <label style="font-weight:600">State:</label> {{State}}</div>
            <div class="form-group col-md-4">
                <label style="font-weight:600">ZIP:</label> {{ZIP}}</div>
        </div>
    </div>
</p-panel>
<div style="padding-top:15px;">
    <p-tabMenu #menuItems [model]="items" [activeItem]="activeItem" (click)="activateMenu()"></p-tabMenu>
    <div *ngIf="tabname=='Job logs'">
        <p-table #dt [columns]="JobsCols" [value]="JobsLog" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20]" [rows]="10"
            sortMode="multiple" [responsive]="true" [globalFilterFields]="['JobStartTime','JobEndTime','RequestBody','ResponseXml','jobStatus','QueryId','QueryType','ErrorDescription']"
            class="mytable">
            <ng-template pTemplate="caption">

                <div class="d-flex flex-row-reverse bd-highlight">
                    <div class="bd-highlight text-right">
                        <div class="input-group input-group-sm" style="max-width: 300px;">
                            <input type="text" class="form-control" placeholder="search" pInputText size="50" placeholder="Search Filter" (input)="dt.filterGlobal($event.target.value, 'contains')">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button">
                                    <i class="icon md-search" title="Edit"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        <div *ngIf="col.field == 'JobStartTime'">
                            {{rowData[col.field] | date: 'MM/dd/yyyy hh:mm a'}}
                        </div>
                        <div *ngIf="col.field == 'JobEndTime'">
                            {{rowData[col.field] | date: 'MM/dd/yyyy hh:mm a'}}
                        </div>
                        <div *ngIf="col.field == 'RequestBody'" class="break-word">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'ResponseXml'">
                            <span *ngIf="rowData.ResponseXml==null">
                                {{NA}}
                            </span>
                            <span *ngIf="rowData.ResponseXml!=null">
                                <a target="_blank" href="{{rowData.ResponseXml}}">View response xml</a>
                            </span>
                        </div>
                        <div *ngIf="col.field == 'jobStatus'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'QueryId'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'QueryType'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'ErrorDescription'" class="break-word">
                            {{rowData[col.field]}}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div *ngIf="tabname=='File transfer logs'">
        <p-table #dt [columns]="FilesCols" [value]="FilesLog" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20]"
            [rows]="10" sortMode="multiple" [responsive]="true" [globalFilterFields]="['FtpStartTime','FtpEndTime','FileType','category','ftpLocation','EntityName','ftpStatus']"
            class="mytable">
            <ng-template pTemplate="caption">
                <div class="d-flex flex-row-reverse bd-highlight">
                    <div class="bd-highlight text-right">
                        <div class="input-group input-group-sm" style="max-width: 300px;">
                            <input type="text" class="form-control" placeholder="search" pInputText size="50" placeholder="Search Filter" (input)="dt.filterGlobal($event.target.value, 'contains')">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button">
                                    <i class="icon md-search" title="Edit"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        <div *ngIf="col.field == 'FtpStartTime'">
                            {{rowData[col.field] | date: 'MM/dd/yyyy hh:mm a'}}
                        </div>
                        <div *ngIf="col.field == 'FtpEndTime'">
                            {{rowData[col.field] | date: 'MM/dd/yyyy hh:mm a'}}
                        </div>
                        <div *ngIf="col.field == 'FileType'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'category'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'ftpLocation'" class="break-word">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 's3Location'">
                            <span>
                                <a target="_blank" href="{{rowData.s3Location}}">View</a>
                            </span>
                        </div>
                        <div *ngIf="col.field == 'EntityName'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.field == 'ftpStatus'">
                            {{rowData[col.field]}}
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<style>
    .break-word {
        word-break: break-all;
        max-width: 240px;
    }
</style>